import {getActivePinia, type Pinia, type Store} from 'pinia'

interface ExtendedPinia extends Pinia {
    _s: Map<string, Store>
}

/** Composable that bundles the two reset operations the app needs. */
export function useResetStores() {
    const resetAll = () => {
        const pinia = getActivePinia() as ExtendedPinia | null
        if (!pinia) return
        pinia._s.forEach((store) => store.$reset?.())
    }

    const resetMany = (stores: Store[]) => {
        if (!stores || stores.length === 0) return
        stores.forEach((store) => store.$reset?.())
    }

    return {resetAll, resetMany}
}
